import Vue from 'vue'
import { getProductImageUrl } from 'util/turnto-utils'

export default Vue.extend({
  props: {
    catItem: {
      type: Object,
      required: true
    },
    includeAlt: {
      type: Boolean,
      default: true
    },
    isLinkable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'L'
    },
    siblingSiteKey: { type: String }
  },
  computed: {
    imageUrl() {
      return getProductImageUrl(this.catItem, this.size, this.siblingSiteKey)
    }
  },
  render(h) {
    // Ugly using render instead of a normal <template>, but we don't have a difinitive root
    // element for the <template>, which Vue requires.  If linkable, then the root is <a>,
    // otherwise, the root is <img>
    // A way around this would be to wrap in a div, which product image usually is, would
    // just need to be able to apply the necessary classes.
    const img = h(
      'img',
      {
        attrs: {
          src: this.imageUrl,
          alt: this.includeAlt ? this.catItem.title : '',
          class: 'tt-o-product__image'
        }
      }
    )
    if (!this.isLinkable) {
      return img
    }
    return h(
      'a', {
        attrs: {
          href: this.catItem.url,
          target: '_blank',
          rel: 'nofollow',
          class: 'tt-o-product__image-link'
        }
      },
      [img]
    )
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/product-image/product-image.ts